export default {
  namespaced: true,
  state: {
    collapsed: false
  },
  getters: {
    collapsed: state => state.collapsed
  },
  mutations: {
    collapse(state, bool) {
      state.collapsed = bool
    }
  },
  actions: {
    collapse(state, bool) {
      state.commit("collapse", bool)
    }
  }
}
